var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7062 22.7063C17.3155 23.0969 16.6824 23.0969 16.2924 22.7063C15.9024 22.3156 15.9018 21.6825 16.2924 21.2925L20.5874 17L8.99984 17C8.44983 17 7.99983 16.55 7.99983 16C7.99983 15.45 8.44708 15 8.99984 15L20.5874 15L16.2943 10.7069C15.9037 10.3162 15.9037 9.68312 16.2943 9.29313C16.6849 8.90313 17.318 8.9025 17.708 9.29313L23.7081 15.2931C23.9 15.4875 24 15.7437 24 16C24 16.2563 23.9024 16.5118 23.707 16.7069L17.7062 22.7063ZM15.9999 32C7.16232 32 -0.000244141 24.8375 -0.000244141 16C-0.000244141 7.1625 7.16232 0 15.9999 0C24.8375 0 32 7.1625 32 16C32 24.8375 24.8375 32 15.9999 32ZM15.9999 2C8.28108 2 1.99977 8.28125 1.99977 16C1.99977 23.7188 8.28108 30 15.9999 30C23.7187 30 30 23.7187 30 16C30 8.28125 23.7187 2 15.9999 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircle);
export default __webpack_public_path__ + "static/media/arrow-right-circle.c4955cb61bd95da179577f7199be4996.svg";
export { ForwardRef as ReactComponent };